<div class="fullPage-promotionDetail-container" *ngIf="exploreRewardDetail">
  <app-reward-detail [exploreReward]="exploreRewardDetail" [channelId]="channelId" [fullpagePromotion]=" true">
  </app-reward-detail>
</div>

<!-- Share Dialog -->
<p-dialog position="bottom" [(visible)]="showShare" [baseZIndex]="9999" *ngIf="showShare" [modal]="false"
  [dismissableMask]="true" [blockScroll]="true" styleClass="fullScreen-dialog fullScreenWithBlack-dialog">
  <app-social-share [url]="shareUrl" [title]="shareStoreName"
    [description]="shareStoreName? ('share.description' | translate: { storeName: shareStoreName }): ''"
    (onClickAction)="showShare = false"></app-social-share>
</p-dialog>

<p-dialog position="bottom" [(visible)]="showStore" *ngIf="showStore && storeList" [modal]="true"
  [dismissableMask]="true" [blockScroll]="true" styleClass="halfScreen-dialog showStore-dialog">
  <app-nearby-store [storeList]="storeList" [currency]="currency"
    [showRewardDialog]="rewardSectionType === rewardSectionTypes.Explore" [currentCart]="cartModel">
  </app-nearby-store>
</p-dialog>